import React, { useEffect, useState } from "react";
import "./MatchedLoads.scss";
import {
  recommendedErrorButton,
  addCapacityErrorButton,
  RECOMMENDED_TAB,
  watchedEmptyText,
  WATCHED_TAB,
  GET_RECOMMEND_LIST_TEXT,
  MANAGE_CAPACITY_TEXT,
  recommendedApiError,
  Navigate_Module,
  pickUpStartDate,
  SORTING_ORDER_ASC,
  PCmiler,
  RECOMMENDED_TAB_HEADING,
  WATCHED_TAB_HEADING
} from "../../../utils/constants";
import { EVENT, SCREEN, TAB } from "../../../utils/constants.analytics";
import { IONICWrapper, isEntitled } from "../../../utils/common";
import Tabs from "../../../web/components/tabs";
import { IonRow, IonCol } from "@ionic/react";
import ToggleButton from "../../../web/components/toggle-button/ToggleButton";
import { Empty } from "../../../web/components/empty";
import { useHistory } from "react-router";
import { LoadsList } from "../../../web/components/loads-list";
import { ShipmentMap } from "../../../web/components/pcmiler-map";
import { logEvent, setScreenName } from "../../../utils/Analytics";
import SortingOptions from "../../../components/core/SortOptions/SortingOptions";
import { getSortOptions } from "../../../utils/SortOptions/SortOptions";
import ShowLoadCountBtn from "../../components/ShowLoadCountBtn/ShowLoadCountBtn";
import { GoogleShipmentMap } from "../../../web/components/google-map";

const PATH = "/app/home";

export const MatchedLoads: React.FC<any> = (props: any) => {
  const {
    history,
    recommendedLoads,
    watchedLoads,
    toggleWatchLoad,
    isHome = false,
    totalRecommendedRecords,
    totalWatchedRecords,
    pageSize,
    currentPage,
    onRedirectToTab,
    resultId,
    shouldShowLoadMoreUpdate
  } = props;
  const sections = [RECOMMENDED_TAB, WATCHED_TAB].filter((tab) =>
    isEntitled("home", tab)
  );
  const [segment, setSegment] = useState<{ name: string; data: object }>({
    name: isHome?sections[0]:props?.watchedTab?sections[1]:sections[0],
    data: {},
  });
  const [loads, setLoads] = useState<any>(isHome?recommendedLoads:props?.watchedTab?watchedLoads:recommendedLoads);
  const [module, setModule] = useState<any>(isHome?`${PATH + RECOMMENDED_TAB}`:props?.watchedTab?`${PATH + WATCHED_TAB}`:`${PATH + RECOMMENDED_TAB}`);
  const [showMap, setShowMap] = useState<boolean>(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const [usePCmilerMaps, setPCmilerMaps] = useState<boolean>(false);
  const history1 = useHistory();
  useEffect(() => {
    if (history1 && history1.location && history1.location.state) {
      setSegment({
        name:
          props.topRecommNavigate ? props.topRecommNavigate : (history1.location.state as any).subSegment === WATCHED_TAB
            ? sections[1]
            : sections[0],
        data: {},
      });
    }
    setValueusePCmilerMaps();
  }, [history,props.topRecommNavigate]);
  useEffect(() => {
    setScreenName(
      segment.name === TAB.RECOMMENDED && !props?.watchedTab
        ? 'screen_recommended'
        : 'screen_watched'
    );
    logEvent(
      segment.name === TAB.RECOMMENDED && !props?.watchedTab
        ? EVENT.UE_VIEW_RECOMMENDED_TAB
        : EVENT.UE_VIEW_WATCHED_TAB,
      {
        screen: SCREEN.HOME,
        tab: segment.name,
      }
    );

    segment.name === TAB.WATCHED &&
     (isHome ? watchedLoads.length > 0 : watchedLoads.length >= 0)  &&
      props.getWatchedLoads(
        props.userDetails,
        props.watchedData,
        props.setPaginationValues,
        true,
        0,
        false,
        pickUpStartDate,
        SORTING_ORDER_ASC,
        props.roles,
        true
      );
     if(segment.name === RECOMMENDED_TAB)
     {
      !isHome && props.getRecommendedLoads(true, 0);
     }
      setValueusePCmilerMaps();

  }, [segment.name]);

  const setValueusePCmilerMaps = () => {
    // ContentStack option to use PCmiler Maps or Google Maps
    const _usePCmilerMaps = IONICWrapper.details.keys
      && IONICWrapper.details.keys.configuration.usePCmilerMaps
      || PCmiler.usePCmilerMaps;
    const isPCmilerMaps = _usePCmilerMaps === "true" ? true : false;
    setPCmilerMaps(isPCmilerMaps);
  }

  const getLoadsList = (name: string) => {
    return (name === RECOMMENDED_TAB) ? recommendedLoads.map(
      (load: any) => ({
        ...load,
        isWatched:
          watchedLoads.find(
            (details: any) => details.loadId === load.loadId
          ) !== undefined,
        similarLoads: (load.similarLoads && load.similarLoads.length && typeof load.similarLoads[0] === "object") ? load.similarLoads.map((similarLoad: any) => ({ ...similarLoad, isWatched: watchedLoads.find((details: any) => details.loadId === similarLoad.loadId) !== undefined })) : [...load.similarLoads],
      })
    ) :
      watchedLoads
        .map(
          (load: any) => ({
            ...load,
            isWatched:
              watchedLoads.find(
                (details: any) => details.loadId === load.loadId
              ) !== undefined,
          })
        )
  };

  useEffect(() => {
    const loadsList = getLoadsList(segment.name);
    setLoads(loadsList);
    setValueusePCmilerMaps();

  }, [recommendedLoads, watchedLoads]);

  const handleTabChange = (data: any) => {
    const loadsList = getLoadsList(data.name);
    setLoads(loadsList);
    setModule(`${PATH + data.name}`);
    setSegment(data);
    props.tabCallbackSegmentChange(data)
  };

  const handleClick = (e: any) => {
    if (e === "search") {
      const isSearchRoute = history1 && history1.location && history1.location.pathname || "";
      isSearchRoute === Navigate_Module.search ? onRedirectToTab('New Search') : history && history.push(Navigate_Module.search);
    } else {
      history && history.push("/app/manage-capacity");
    }
  };
  const [shipmentToExpand, setShipmentToExpand] = useState<any>({});
  const onCloseMapView = (shipment: any) => {
    setShowMap(false);
    setShipmentToExpand((shipment && shipment.shipment) || {});

    history &&
      history.push({
        pathname: "/app/search",
        state: {
          segmenName: "Matched Loads",
          subSegment: segment.name,
          shipmentToExpand: (shipment?.shipment) || {},
        },
      });
  };
  const recommendationsText =
    totalRecommendedRecords === 1 ? "Recommendation" : "Recommendations";
  const watchedText =
    totalWatchedRecords === 1 ? "Watched load" : "Watched loads";

  const onChangeRowIndex = () => {
    setTimeout(() => {
      const pointer = document.getElementsByClassName("load-map-grid")[0];
      pointer?.scrollIntoView();
    }, 2000);
  };

  const locState: any = history1.location.state || {};
  useEffect(() => {
    if (locState.shipmentToExpand) {
      setShipmentToExpand(locState.shipmentToExpand);
    }
    setValueusePCmilerMaps();
  }, [locState.shipmentToExpand]);

  useEffect(() => {
    if (props.isRecommendedLoaded || props.getRecommendedApiError) {
      const message = IONICWrapper.details.keys?.configuration.noRecommendedDataMessage;
      setNoDataMessage(
        props.noRecommendationMessage || message || recommendedApiError
      );
    }
    setValueusePCmilerMaps();
  }, [props.isRecommendedLoaded, props.noRecommendationMessage, props.getRecommendedApiError]);

  return (
    <div className="sni-matched-wrapper">
      {isHome ? <IonRow className="matched-header">
        <IonCol size="9">
          <div className="matched-loads-title">Matched Loads</div>
        </IonCol>
        <IonCol size="3">
          <ToggleButton
            isMapActive={true}
            handleChange={(value: string) => setShowMap(value === "map")}
          />
        </IonCol>
      </IonRow> :
      <>
      <IonRow className="matched-header new-segment">
      <IonCol size="3">
        <ToggleButton
          isMapActive={true}
          handleChange={(value: string) => setShowMap(value === "map")}
        />
      </IonCol>
    </IonRow>
    </>
      }
      {isHome ?  <Tabs
        setSegment={handleTabChange}
        segments={sections}
        activeSegment={segment.name}
      > 
      
        {!showMap ? (
          loads && loads.length > 0 ? (
            <>
              {segment.name === RECOMMENDED_TAB ? null : (
                <IonRow class="list-items-header-matchloads sort-only-wrapper-matchloads">
                  <IonCol size="12" class="sort_select">
                    <div className="select_div">
                      <SortingOptions
                        options={getSortOptions(false, false)}
                        sortedData={props.onSortedData}
                      />
                    </div>
                  </IonCol>
                </IonRow>
              )}
              <div className="total-load-count">
                {segment.name === RECOMMENDED_TAB
                  ? `${totalRecommendedRecords} ${recommendationsText}`
                  : `${totalWatchedRecords} ${watchedText}`}
              </div>
              <LoadsList
                topRecommNavigate={props.topRecommNavigate}
                topRecommLoadClick={props.topRecommLoadClick}
                shipmentToExpand={shipmentToExpand}
                loads={loads}
                module={module}
                history={history}
                toggleWatchLoad={toggleWatchLoad}
                isNetworkAvailable={props.isNetworkAvailable}
                userDetails={props.userDetails}
                buyLoadRequest={props.buyLoadRequest}
                bookLoadStatus={props.bookLoadStatus}
                getShipmentDetails={props.getShipmentDetails}
                buyLoadStatusRemove={props.buyLoadStatusRemove}
                buyLoadShipmentRequest={props.buyLoadShipmentRequest}
                fetchShipments={props.fetchShipments}
                carrierLoads={props.carrierLoads}
                removeSearchResults={props.removeSearchResults}
                removeRecommendedResults={props.removeRecommendedResults}
                removewatchedResults={props.removewatchedResults}
                isCarrierLoad={false}
                onChangeRowIndex={onChangeRowIndex}
                fetchSimilarLoads={props.fetchSimilarLoads}
                fetchAvailableLoads={props.fetchAvailableLoads}
                resultId={resultId}
                isMatchedLoadPage={true}
                clearTopRecommedLoadDetails={props.clearTopRecommedLoadDetails}
                onRedirectToTab={props.onRedirectToTab}
              />

              {segment.name === RECOMMENDED_TAB ? (
                <div className="end-of-list">End of list</div>
              ) : totalWatchedRecords === loads.length ? (
                <div className="end-of-list">End of list</div>
              ) : (
                <ShowLoadCountBtn
                onShowMore={props.onShowMore}
                shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
                totalRecords={totalWatchedRecords}
                currentPage={currentPage}
                pageSize={pageSize}
              />
              )}
            </>
          ) : (
            <Empty
              constantText={
                segment.name === RECOMMENDED_TAB
                  ? noDataMessage
                  : watchedEmptyText
              }
              constantButton={recommendedErrorButton}
              constantAddButton={addCapacityErrorButton}
              segmentName={segment.name}
              handleClick={handleClick}
              redirectTo="/app/search"
            />
          )
        ) : (
          <React.Fragment>
            <div className="total-load-count">
              {segment.name === RECOMMENDED_TAB
                ? `${totalRecommendedRecords} ${recommendationsText}`
                : `${totalWatchedRecords} ${watchedText}`}
            </div>
              {usePCmilerMaps ? (
                <ShipmentMap
                  shipments={
                    segment.name == RECOMMENDED_TAB
                      ? recommendedLoads
                      : watchedLoads
                  }
                  onCloseMapView={onCloseMapView}
                />) : (
                <GoogleShipmentMap
                  shipments={
                    segment.name == RECOMMENDED_TAB
                      ? recommendedLoads
                      : watchedLoads
                  }
                  onCloseMapView={onCloseMapView}
                />
              )}
          </React.Fragment>
        )}
      </Tabs> : <>{!showMap ? (
          loads && loads.length > 0 ? (
            <>
              {segment.name === RECOMMENDED_TAB ? null : (
                <IonRow className={`${
                  isHome ? "list-items-header-matchloads sort-only-wrapper-matchloads" : "list-items-header-matchloads sort-only-wrapper-watchloads"
                }`}>
                  <IonCol size="12" class="sort_select">
                    <div className="select_div">
                      <SortingOptions
                        options={getSortOptions(false, false)}
                        sortedData={props.onSortedData}
                      />
                    </div>
                  </IonCol>
                </IonRow>
              )}
              <div className="total-load-count">
                {segment.name === RECOMMENDED_TAB
                  ? `${totalRecommendedRecords} ${recommendationsText}`
                  : `${totalWatchedRecords} ${watchedText}`}
              </div>
              <LoadsList
                topRecommNavigate={props.topRecommNavigate}
                topRecommLoadClick={props.topRecommLoadClick}
                shipmentToExpand={shipmentToExpand}
                loads={loads}
                module={module}
                history={history}
                toggleWatchLoad={toggleWatchLoad}
                isNetworkAvailable={props.isNetworkAvailable}
                userDetails={props.userDetails}
                buyLoadRequest={props.buyLoadRequest}
                bookLoadStatus={props.bookLoadStatus}
                getShipmentDetails={props.getShipmentDetails}
                buyLoadStatusRemove={props.buyLoadStatusRemove}
                buyLoadShipmentRequest={props.buyLoadShipmentRequest}
                fetchShipments={props.fetchShipments}
                carrierLoads={props.carrierLoads}
                removeSearchResults={props.removeSearchResults}
                removeRecommendedResults={props.removeRecommendedResults}
                removewatchedResults={props.removewatchedResults}
                isCarrierLoad={false}
                onChangeRowIndex={onChangeRowIndex}
                fetchSimilarLoads={props.fetchSimilarLoads}
                fetchAvailableLoads={props.fetchAvailableLoads}
                resultId={resultId}
                isMatchedLoadPage={true}
                clearTopRecommedLoadDetails={props.clearTopRecommedLoadDetails}
                onRedirectToTab={props.onRedirectToTab}
              />

              {segment.name === RECOMMENDED_TAB ? (
                <div className="end-of-list">End of list</div>
              ) : totalWatchedRecords === loads.length ? (
                <div className="end-of-list">End of list</div>
              ) : (
                <ShowLoadCountBtn
                onShowMore={props.onShowMore}
                shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
                totalRecords={totalWatchedRecords}
                currentPage={currentPage}
                pageSize={pageSize}
              />
              )}
            </>
          ) : (
            <Empty
              constantText={
                segment.name === RECOMMENDED_TAB
                  ? noDataMessage
                  : watchedEmptyText
              }
              constantButton={recommendedErrorButton}
              constantAddButton={addCapacityErrorButton}
              segmentName={segment.name}
              handleClick={handleClick}
              redirectTo="/app/search"
            />
          )
        ) : (
          <React.Fragment>
            <div className="total-load-count">
              {segment.name === RECOMMENDED_TAB
                ? `${totalRecommendedRecords} ${recommendationsText}`
                : `${totalWatchedRecords} ${watchedText}`}
            </div>
              {usePCmilerMaps ? (
                <ShipmentMap
                  shipments={
                    segment.name == RECOMMENDED_TAB
                      ? recommendedLoads
                      : watchedLoads
                  }
                  onCloseMapView={onCloseMapView}
                />) : (
                <GoogleShipmentMap
                  shipments={
                    segment.name == RECOMMENDED_TAB
                      ? recommendedLoads
                      : watchedLoads
                  }
                  onCloseMapView={onCloseMapView}
                />
              )}
          </React.Fragment>
        )}
           </>     }
      {!isHome ? (
        <div className="manage-cap-search">
          <div>{GET_RECOMMEND_LIST_TEXT}</div>
          <span
            onClick={() => {
              history.push("/app/manage-capacity/add");
            }}
          >
            {MANAGE_CAPACITY_TEXT} <i className="custom-arr"></i>
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default MatchedLoads;